// export * from './sales-lead-type.component';
export * from './sales-lead-type-view.component';
export * from './sales-lead-type-add-edit.component';